import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { InvoiceService } from "./../../../../_services/invoice.service";
import { Config } from "src/app/_store/config";

@Component({
  selector: "app-ledger-upload",
  templateUrl: "./ledger-upload.component.html",
  styleUrls: ["./ledger-upload.component.scss"],
})
export class LedgerUploadComponent implements OnInit {
  Config = Config;
  @ViewChild('sizeErrorModal') sizeErrorModal: TemplateRef<any>;
  invoiceTypes = [
    { label: "IRN e-invoice", type: "e-invoice" },
    { label: "Digitally Signed e-invoice", type: "ds-invoice" },
  ];
  noteTypes = [
    { label: "Credit Note", type: "CN" },
    { label: "Debit Note", type: "DN" },
  ];
  selectedCompany: any;
  file: any;
  impersonate;

  docs: any;

  loading = false;
  fileTypeError = false;
  qrCodeError = false;
  signatureError = false;
  validateSignature = false;
  validateEinvoice = false;
  validateEinvoiceResubmit = false;
  fileSizeError = false;
  responseData: any;
  displayName: any;
  message: any;
  poItems = [];
  files: any = [];
  poNo: any;
  fileUrl: any;
  safeUrl: any;
  pdfSrc: any;
  fileName: string = "";
  errorMessage: string = "";
  dsLoaderMsg = "";
  eLoaderMsg = "";
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  eLoaderMsgResubmit = "";
  timeoutID;
  formSubmitted = false;
  unathourizedEmail = false;
  previousUrl: any;
  companies: any;
  organisations: any;
  configResCompanies: any;
  configResOrg: any;
  configResDocs: any;
  emailRes: any;
  docsLoaded = false;
  orgsLoaded = false;
  companyCodesLoaded = false;

  ledgerData = new FormGroup({
    invoiceType: new FormControl(null, [Validators.required]),
    noteType: new FormControl(null, [Validators.required]),
    file: new FormControl(null),
    fileSource: new FormControl("", [Validators.required]),
    email: new FormControl("", [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    poNo: new FormControl("", [Validators.minLength(10), Validators.maxLength(10)]),
    companyCode: new FormControl("", [Validators.required]),
    purchaseOrg: new FormControl("", [Validators.required]),
    docType: new FormControl("", [Validators.required]),
  });

  constructor(private router: Router, private route: ActivatedRoute, private http: HttpClient, private invoiceService: InvoiceService, private authService: AuthService, private modalService: NgbModal) {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.previousUrl = this.route.snapshot.queryParams["returnUrl"] || "dashboard";
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }
  selectInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];
      if (fileUploaded.type !== "application/pdf") {
        this.fileTypeError = true;
      } else if (fileUploaded.size > Config.maxFileSize) {
        this.fileSizeError = true;
        this.modalService.open(this.sizeErrorModal, { centered: true, size: 'sm' });
      } else {
        this.ledgerData.patchValue({
          fileSource: fileUploaded,
        });
        this.fileTypeError = false;
        this.fileSizeError = false;
      }
    }

    this.fileName = event[0].name;
    this.invoiceService.setFileElement(event[0]);
    localStorage.setItem("invoiceFile", event[0]);
  }

  extrationMessages(msg, time) {
    this.timeoutID = setTimeout(() => {
      this.eLoaderMsg = msg;
    }, time);
  }

  extrationResubmitMessages(msg, time) {
    this.timeoutID = setTimeout(() => {
      this.eLoaderMsgResubmit = msg;
    }, time);
  }

  onLedgerSubmit() {
    if (this.fileSizeError || this.fileTypeError) {
      return;
    }
    this.loading = true;
    this.formSubmitted = true;
    this.qrCodeError = false;
    this.signatureError = false;

    if (this.ledgerData.value.invoiceType === "e-invoice") {
      this.validateEinvoice = true;
      this.validateSignature = false;

      const validateEmailData = {
        action: "list",
        email: this.ledgerData.value.email,
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
      };

      if (true) {
        if (true) {
          this.invoiceService.setUsername("test");
          this.invoiceService.setUserId("test");
          this.invoiceService.setInvoiceType("non_po_based");

          this.invoiceService.setInvType("e-invoice");
          this.invoiceService.setNoteType(this.ledgerData.value.noteType);
          if (this.ledgerData.value.noteType === "CN") {
            localStorage.setItem("document", "Credit Note");
          } else {
            localStorage.setItem("document", "Debit Note");
          }

          // Create ledger array similar to invoice-submission component
          const ledger: any[] = [
            {
              docType: this.ledgerData.value.docType,
              docDetail: {
                docFormat: "e-invoice",
                docCat: "non_po_based",
              },
              cmpCode: this.ledgerData.value.companyCode,
              purchaseOrg: this.ledgerData.value.purchaseOrg,
              erpDocType: this.ledgerData.value.docType,
            },
          ];

          const userData = {
            req: {
              emailAddress: this.ledgerData.value.email,
              companyCode: this.ledgerData.value.companyCode,
              purchaseOrg: this.ledgerData.value.purchaseOrg,
              docType: this.ledgerData.value.docType,
              poNo: this.ledgerData.value.poNo,
              username: "",
              userId: "",

              items: [
                {
                  barcode: "",
                  poNo: "",
                  itemNo: "",
                  grn: "",
                },
              ],
            },
            file: this.ledgerData.value.fileSource,
          };

          const formData: any = new FormData();
          formData.append("sellerCode", localStorage.getItem("sellerCode"));
          formData.append("supplierCode", localStorage.getItem("vendorCode"));
          formData.append("ledger", JSON.stringify(ledger));
          formData.append("invoiceFile", this.ledgerData.value.fileSource);
          formData.append("extractionVersion", "1");

          this.eLoaderMsg = "Verifying QR Code";
          this.extrationMessages("Authenticating QR Code", 5000);
          this.extrationMessages("Extracting Data", 10000);
          this.extrationMessages("Validating Data", 15000);

          this.invoiceService.extractInvoice(formData).subscribe(
            (res) => {
              this.loading = false;
              this.validateEinvoice = false;
              this.validateSignature = false;
              this.responseData = res;
              clearTimeout(this.timeoutID);

              if (this.responseData.length !== 0 && this.responseData.status === "error") {
                console.log("error");

                if (this.responseData.msg.includes("unreadable")) {
                  this.loading = true;
                  this.validateEinvoiceResubmit = true;

                  this.eLoaderMsgResubmit = "Sorry, QR code in your uploaded file is not legible. We will optimize your file now and retry.";

                  formData.set("extractionVersion", "2");

                  this.extrationResubmitMessages("Verifying QR Code", 5000);
                  this.extrationResubmitMessages("Authenticating QR Code", 10000);
                  this.extrationResubmitMessages("Extracting Data", 15000);
                  this.extrationResubmitMessages("Validating Data", 20000);

                  setTimeout(() => {
                    this.invoiceService.extractInvoice(formData).subscribe(
                      (res) => {
                        this.responseData = res;

                        if (this.responseData.length !== 0 && this.responseData.status === "error") {
                          this.validateEinvoiceResubmit = false;
                          this.qrCodeError = true;
                          this.message = this.responseData.msg;
                        } else {
                          console.log("Success - E-invoice resubmit extracted:", this.responseData);
                          this.qrCodeError = false;
                          this.invoiceService.setProcessedInvoice(this.responseData);
                          localStorage.setItem("invoiceDetails", JSON.stringify(this.responseData));
                          this.router.navigateByUrl("/ledger-preview");
                        }
                      },
                      (error) => {
                        console.log("E-invoice resubmit error:", error);
                        this.loading = false;
                        this.validateEinvoiceResubmit = false;
                        this.qrCodeError = true;
                        this.message = error.msg;
                      }
                    );
                  }, 22000);
                }
              } else {
                console.log("Success - E-invoice extracted:", this.responseData);
                this.qrCodeError = false;

                // Map response data to processedInvoice structure for e-invoice
                const meta = this.responseData.data?.meta || {};
                const rec = this.responseData.data?.rec || {};
                const docDetail = rec.docDetail || {};
                const processedInvoice = {
                  file_link: this.responseData.data.meta.src,
                  supporting_docs: this.responseData.data.meta.supportingDocsSrc || [],
                  invoice_number: this.responseData.data.rec.docId,
                  invoice_date: this.responseData.data.meta.docDate,
                  invoice_amount: this.responseData.data.rec.docDetail.docAmt,
                  irn: this.responseData.data.rec.docDetail.docIrn,
                  gstin: this.responseData.data.rec.docDetail.docGstin,
                  cmpCode: this.ledgerData.value.companyCode,
                  purchaseOrg: this.ledgerData.value.purchaseOrg,
                  erpDocType: this.responseData.data.rec.docDetail.docType,
                  poNo: this.ledgerData.value.poNo,
                  username: this.invoiceService.getUsername(),
                  user_id: this.invoiceService.getUserId(),
                  barcodePrefix: this.responseData.data.rec.barcodePrefix,
                  docFormat: "e-invoice",
                  email: this.ledgerData.value.email,
                };

                this.invoiceService.setProcessedInvoice(processedInvoice);
                localStorage.setItem("invoiceDetails", JSON.stringify(processedInvoice));
                this.router.navigateByUrl("/ledger-preview");
              }
            },
            (error) => {
              console.log("E-invoice extraction error:", error);
              this.loading = false;
              this.validateEinvoice = false;
              this.validateSignature = false;
              this.responseData = error;
              this.qrCodeError = true;
              this.message = error.msg;
            }
          );
        } else {
        }
      } else {
      }
    } else {
      this.validateSignature = true;
      this.validateEinvoice = false;

      this.poNo;

      const validateEmailData = {
        action: "list",
        email: this.ledgerData.value.email,
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
      };

      if (true) {
        if (true) {
          this.invoiceService.setInvoiceType("non_po_based");
          this.invoiceService.setInvType("ds-invoice");
          this.invoiceService.setNoteType(this.ledgerData.value.noteType);
          this.invoiceService.setUsername("test");
          this.invoiceService.setUserId("test");
          this.invoiceService.setPo(this.ledgerData.value.poNo);

          // Create ledger array similar to invoice-submission component
          const ledger: any[] = [
            {
              docType: this.ledgerData.value.docType,
              docDetail: {
                docFormat: "ds-invoice",
                docCat: "non_po_based",
              },
              cmpCode: this.ledgerData.value.companyCode,
              purchaseOrg: this.ledgerData.value.purchaseOrg,
              erpDocType: this.ledgerData.value.docType,
            },
          ];

          const fields = {
            emailAddress: this.ledgerData.value.email,
            companyCode: this.ledgerData.value.companyCode,
            purchaseOrg: this.ledgerData.value.purchaseOrg,
            docType: this.ledgerData.value.docType,
            poNo: this.ledgerData.value.poNo,
            username: "",
            userId: "",
            items: [
              {
                poNo: this.ledgerData.value.poNo,
                itemNo: "",
                grn: "",
                barcode: "",
              },
            ],
          };

          this.invoiceService.setNonPOFields(fields);
          const formData: any = new FormData();
          formData.append("sellerCode", localStorage.getItem("sellerCode"));
          formData.append("supplierCode", localStorage.getItem("vendorCode"));
          formData.append("ledger", JSON.stringify(ledger));
          formData.append("invoiceFile", this.ledgerData.value.fileSource);
          this.dsLoaderMsg = "Verifying Signature";

          setTimeout(() => {
            this.dsLoaderMsg = "Authenticating Signature";
          }, 2000);
          setTimeout(() => {
            this.dsLoaderMsg = "Extracting Data";
          }, 4000);
          setTimeout(() => {
            this.dsLoaderMsg = "Validating Data";
          }, 6000);

          this.invoiceService.verifyDigitalSignature(formData).subscribe(
            (res) => {
              this.loading = false;
              this.validateEinvoice = false;
              this.validateSignature = false;
              this.responseData = res;
              console.log(this.responseData, "this.responseData");

              if (this.responseData.length !== 0 && this.responseData.status === "error") {
                this.loading = true;
                this.signatureError = true;
                this.message = this.responseData.msg;
              } else {
                console.log("Success - Digital signature verified");
                this.qrCodeError = false;
                this.poNo = this.route.snapshot.params["poNo"];

                // Map response data to processedInvoice structure for digitally signed invoice
                const meta = this.responseData.data?.meta || {};
                const rec = this.responseData.data?.rec || {};
                const docDetail = rec.docDetail || {};
                const processedInvoice = {
                  file_link: this.responseData.data.meta.src,
                  supporting_docs: this.responseData.data.meta.supportingDocsSrc || [],
                  invoice_number: this.responseData.data.rec.docId,
                  invoice_date: this.responseData.data.meta.docDate,
                  invoice_amount: this.responseData.data.rec.docDetail.docAmt,
                  irn: this.responseData.data.rec.docDetail.docIrn,
                  gstin: this.responseData.data.rec.docDetail.docGstin,
                  cmpCode: this.ledgerData.value.companyCode,
                  purchaseOrg: this.ledgerData.value.purchaseOrg,
                  erpDocType: this.ledgerData.value.docType,
                  poNo: this.ledgerData.value.poNo,
                  username: this.invoiceService.getUsername(),
                  user_id: this.invoiceService.getUserId(),
                  barcodePrefix: this.responseData.data.rec.barcodePrefix,
                  docFormat: "ds-invoice",
                  email: this.ledgerData.value.email,
                };

                this.invoiceService.setFileUrl(meta.src);
                this.invoiceService.setDataDigitalInvoice(processedInvoice);
                this.router.navigate(["/digitally-signed-ledger-preview"]);
              }
            },
            (error) => {
              console.log("Digital signature verification error:", error);
              this.loading = false;
              this.validateEinvoice = false;
              this.validateSignature = false;
              this.responseData = error;
              this.qrCodeError = true;
              this.message = error.msg;
            }
          );
        } else {
        }
      } else {
      }
    }
  }

  fetchPurchaseOrg() {
    const configReq = {
      type: "purchaseOrganizations",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResOrg = res;
        if (this.configResOrg.length !== 0 && this.configResOrg.status === "error") {
          console.log(this.configResOrg + " Error");
          this.orgsLoaded = true;
        } else {
          this.organisations = this.configResOrg.data;
          this.orgsLoaded = true;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  fetchCompanyCode() {
    const configReq = {
      type: "companyCodes",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResCompanies = res;
        if (this.configResCompanies.length !== 0 && this.configResCompanies.status === "error") {
          console.log(this.configResCompanies + " Error");
          this.companyCodesLoaded = true;
        } else {
          this.companies = this.configResCompanies.data;
          this.companyCodesLoaded = true;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  fetchDocType() {
    const configReq = {
      type: "purchaseDoc",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResDocs = res;
        if (this.configResDocs.length !== 0 && this.configResDocs.status === "error") {
          console.log(this.configResDocs + " Error");
          this.docsLoaded = true;
        } else {
          this.docs = this.configResDocs.data;
          this.docsLoaded = true;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    if (localStorage.getItem("impersonation") === null || localStorage.getItem("impersonation") === "") {
      this.impersonate = "false";
    } else {
      this.impersonate = localStorage.getItem("impersonation");
    }

    this.fetchCompanyCode();
    this.fetchPurchaseOrg();
    this.fetchDocType();
  }

  closeFileErrorDialog() {
    this.loading = false;
    this.fileTypeError = false;
    this.qrCodeError = false;
  }

  closeSignatureErrorDialog() {
    this.loading = false;
    this.signatureError = false;
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/credit-notes");
  }

  resubmitInvoice() {
    this.router.navigateByUrl("/submit-ledger");
  }
}
